import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api";

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.login(password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--paper)] px-6">
      <form onSubmit={onSubmit} className="w-full max-w-sm">
        <p className="font-serif text-2xl mb-1">Alice Lisi — Admin</p>
        <p className="font-serif text-[13px] text-[color:var(--ink-mute)] mb-8">Enter your password to manage the site.</p>

        <label className="block">
          <span className="font-serif text-[13px] text-[color:var(--ink-mute)]">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoFocus
            className="mt-1 w-full bg-transparent border-b border-[color:var(--ink)] py-2 outline-none font-serif text-lg"
          />
        </label>

        {error && <p className="font-serif text-[13px] text-red-600 mt-3">{error}</p>}

        <button type="submit" disabled={loading} className="btn-sober mt-6 w-full justify-center">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
